import { render, staticRenderFns } from "./blog-slider.vue?vue&type=template&id=bd0b2974&scoped=true&"
import script from "./blog-slider.vue?vue&type=script&lang=js&"
export * from "./blog-slider.vue?vue&type=script&lang=js&"
import style0 from "./blog-slider.vue?vue&type=style&index=0&id=bd0b2974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0b2974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bd0b2974', component.options)
    } else {
      api.reload('bd0b2974', component.options)
    }
    module.hot.accept("./blog-slider.vue?vue&type=template&id=bd0b2974&scoped=true&", function () {
      api.rerender('bd0b2974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/blog-slider.vue"
export default component.exports